<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import { useLearningPathTrainingsStore } from "~/store/learning-path/learning-path-trainings.store";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import Footer from "./Footer.vue";
import SessionsChoice from "../../component/attendees/trainings-tab/sessions/SessionsChoice.vue";
import EmptyState from "../../component/attendees/trainings-tab/sessions/EmptyState.vue";
import EmptyStateCommon from "~/components/Common/EmptyState.vue";
import { useSessionsStore } from "~/store/sessions/sessions-store";
const { handleLearningPathTrainingsSessionsModal, setSessionsDatas } = useLearningPathTrainingsStore();
const { currentTrainingPathId, trainingsDatas, sessionsDatas } = storeToRefs(useLearningPathTrainingsStore());
const training = computed(() =>
  trainingsDatas.value?.find((training: any) => training.learningPathTrainingId === currentTrainingPathId.value),
);
const sessionsStore = useSessionsStore();
const isLoading = ref(true);

const change = (sessionId: string) => {
  sessionsDatas.value.forEach((session: any) => {
    if (session.sessionId === sessionId) {
      session.isCheck = !session.isCheck;
    } else {
      session.isCheck = false;
    }
  });
};

const isOnDemand = computed(() => {
  return trainingsDatas.value?.find(
    (training: any) => training.learningPathTrainingId === currentTrainingPathId.value && training.isOnDemand,
  );
});

onMounted(async () => {
  if (currentTrainingPathId.value) {
    if (isOnDemand.value) {
      isLoading.value = false;
      return;
    } else {
      isLoading.value = true;
      const sessions = await sessionsStore.fetchSessionsByTrainingId({
        trainingId: training.value.trainingId,
        inProgress: "true",
        withProject: "false",
      });

      if (sessions.length) {
        setSessionsDatas(
          sessions.map((session: any) => ({
            ...session,
            isCheck: false,
          })),
        );
      } else {
        setSessionsDatas([]);
      }
      isLoading.value = false;
    }
  }
});
</script>
<template>
  <CenterModal
    style="max-width: 720px; max-height: 688px; width: 100%; height: 100%"
    @hide="handleLearningPathTrainingsSessionsModal(false)"
  >
    <template #body>
      <div class="flex flex-col gap-6 h-full">
        <button
          type="button"
          class="w-full flex justify-end px-4 py-2 cursor-pointer hover:opacity-70 transition-opacity"
          @click="handleLearningPathTrainingsSessionsModal(false)"
        >
          <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="close"></SvgIcon>
        </button>
        <div v-if="isOnDemand" class="body_regular flex px-16 flex-col flex-1">
          <h3 class="heading_3_demi text-primary-color mb-4">Inscription</h3>
          <EmptyStateCommon
            message="Il n'est pas nécessaire de créer des sessions pour ce type de formation."
            icon="tick"
            class="mt-[12px]"
            size="medium"
          >
            <span class="body_regular"> Vous pouvez inscrire les participants directement. </span>
          </EmptyStateCommon>
        </div>
        <div v-else class="body_regular flex px-16 flex-col flex-1">
          <h3 class="heading_3_demi text-primary-color mb-4">Choix de session</h3>

          <!-- Loading state -->
          <div v-if="isLoading" class="flex flex-col items-center justify-center gap-3 mt-[136px]">
            <SvgIcon name="loader" class="w-8 h-8 animate-spin text-primary-blue-color" />
            <span class="body_regular text-secondary-color">Chargement des sessions...</span>
          </div>

          <!-- Sessions list -->
          <div v-else-if="sessionsDatas.length" class="flex flex-col gap-3 mt-4 overflow-y-auto max-h-[472px]">
            <SessionsChoice
              v-for="session in sessionsDatas"
              :key="session.sessionId"
              v-model="session.isCheck"
              :data="session"
              @change="change"
            />
          </div>

          <!-- Empty state -->
          <EmptyState
            v-else
            class="flex items-center justify-center mt-[12px]"
            :redirect="
              () =>
                navigateTo(`/company-catalog?id=${training.trainingId}`, { external: true, open: { target: '_blank' } })
            "
          />
        </div>
        <Footer v-if="!isLoading || isOnDemand" />
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss">
.project__modal {
  @apply grid pt-[48px] pb-[16px];
  display: flex;
  height: 100%;
  flex-direction: column;
}

.project__body {
  height: 100%;
}
</style>
